import React from "react";

export default function Footer() {
    return (
        <p>This project was coded and perfected by <strong>Sanelisiwe Ngubane</strong> and is <a href="https://github.com/SANEH69/saneh-dictionary-react">open-sourced</a>. </p>
    )
}